<script setup lang="ts">
import {Component} from "../types.ts";
import {computed} from "vue";
import useStore from "../store.ts";

const props = defineProps<{
  item: Component
}>();
const duration = props.item.progress_bar_props.duration;
const store = useStore();

const barWidth = computed(() => {
  const time = props.item.data?.get(props?.item?.dynamic?.field?.field)?.value || 0;
  const delta = time - (store.currentDate / 1000);

  if (delta < 0 || delta > duration) {
    return 0;
  }
  return `${100 - Math.round(delta / duration * 100)}%`;
});

</script>
<template>
  <div v-bind="item.props">
    <div :id="`progress-${item.props.id}`" :style="{background: item.progress_bar_props?.bar_color, width: barWidth}">
    </div>
    <slot>
    </slot>

  </div>
</template>

<style scoped>

</style>